import styled from 'styled-components/native';

export const BlackBackground = styled.View`
  background-color: ${(props) => props.theme.color.black};
  width: 100%;
  align-items: center;
`;
